import React from "react";

export default function Love({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25.676"
      height="22.834"
      viewBox="0 0 25.676 22.834"
      className={color}
    >
      <g id="Group_153" dataName="Group 153" transform="translate(0.838 0.751)">
        <path
          id="Path_85"
          dataName="Path 85"
          d="M24.262,13.665,14,24.331,3.735,13.665A6.317,6.317,0,1,1,14,6.557a6.317,6.317,0,1,1,10.263,7.109Z"
          transform="translate(-1.998 -2.998)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}
